import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=450f0ab3&"
var script = {}
import style0 from "./Banner.vue?vue&type=style&index=0&id=450f0ab3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports